import { faBars, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { useCallback, useMemo, useState } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { Controller, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import useAxiosHook from '../../../../../hooks/useAxiosHook';
import AutoCompleteInput from '../../../../Forms/AutoCompleteInput/AutoCompleteInput';

export default function PointRow({
  index,
  methods,
  pointTypes,
  removePointsFields,
}) {
  const { t } = useTranslation();
  const { control, setValue } = methods;
  const points = useWatch({ name: 'points', control }) || [];
  const row = points[index] || {};
  const [searchTerm, setSearchTerm] = useState(row.pointName ?? '');

  const url =
    `/logistics-point?pointTypeId=${row.pointTypeId || 1}` +
    `&keyword=${encodeURIComponent(searchTerm)}`;
  const { data: optData, isLoading } = useAxiosHook(url);

  const options = useMemo(() => {
    return (optData?.data || []).map((p) => ({
      value: p.id,
      label: p.name,
      address: p.address,
    }));
  }, [optData]);

  const handleFilterChange = useCallback((val) => {
    setSearchTerm(val);
  }, []);

  const handleSelect = useCallback(
    (val) => {
      setValue(`points.${index}.entityId`, val);
      const sel = options.find((o) => o.value === val);
      setValue(`points.${index}.pointName`, sel?.label || '');
      setValue(`points.${index}.address`, sel?.address || null);
    },
    [index, options, setValue]
  );

  return (
    <Draggable
      key={row.entityId}
      draggableId={row.entityId?.toString()}
      index={index}
    >
      {(provided) => (
        <tr
          key={row.sequence}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <td {...provided.dragHandleProps}>
            <FontAwesomeIcon icon={faBars} />
          </td>
          {/* {row.sequence} */}
          <td>
            <Controller
              control={control}
              name={`points.${index}.pointTypeId`}
              render={({ field }) => (
                <Dropdown
                  {...field}
                  options={pointTypes}
                  onChange={(e) => field.onChange(e.value)}
                />
              )}
            />
          </td>

          <td>
            <Controller
              control={control}
              name={`points.${index}.maintenanceTimeframe`}
              render={({ field }) => (
                <InputText
                  {...field}
                  onChange={(e) => field.onChange(e.currentTarget.value)}
                />
              )}
            />
          </td>

          <td>
            <Controller
              control={control}
              name={`points.${index}.entityId`}
              render={({ field }) => (
                <AutoCompleteInput
                  filterValue={searchTerm}
                  onFilterChange={handleFilterChange}
                  options={options}
                  isLoading={isLoading}
                  placeholder={t('Search points')}
                  value={field.value}
                  onSelectionChange={handleSelect}
                />
              )}
            />
          </td>

          <td>
            <FontAwesomeIcon
              icon={faTrashAlt}
              onClick={() => removePointsFields(index)}
            />
          </td>
        </tr>
      )}
    </Draggable>
  );
}
